import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        backgroundColor: tokens.bgColorDefault,
        borderEndStartRadius: tokens.radiusSizeM,
        borderEndEndRadius: tokens.radiusSizeM,
        zIndex: 1,
      },
    },

    children: {
      wrap: {
        display: 'block',
        flex: '0 0 auto',

        '& > button': {
          display: 'inline-flex',
        },
      },
    },
  } as const
}
